"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forwarder = void 0;
const schemas_1 = require("@dcl/schemas");
const abis_1 = require("../abis");
exports.forwarder = {
    [schemas_1.ChainId.MATIC_MUMBAI]: {
        version: '2',
        abi: abis_1.abis.Forwarder,
        address: '0x71e56Ad57eca3fAAe5077b7F9ea731a25785fF92',
        name: 'Forwarder',
        chainId: schemas_1.ChainId.MATIC_MUMBAI
    },
    [schemas_1.ChainId.MATIC_MAINNET]: {
        version: '2',
        abi: abis_1.abis.Forwarder,
        address: '0xBF6755A83C0dCDBB2933A96EA778E00b717d7004',
        name: 'Forwarder',
        chainId: schemas_1.ChainId.MATIC_MAINNET
    }
};
//# sourceMappingURL=forwarder.js.map